import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { useSafeThemeUI } from '../../theme-provider/use-theme-ui.esm.js';
import { get } from '../../utils/object.esm.js';
import { omitSpace } from '../../utils/props-utils.esm.js';
import { PanePrivate } from '../_layouts/pane/pane.esm.js';
import { BoxPrivate } from '../_primitives/box/box.esm.js';

var _excluded = ["variant", "placement", "border", "elevation", "Component", "ComponentTransitionProps", "TransitionProps", "title", "arrow", "ignoreNonTouchEvents", "setArrowRef"];
var tooltipPlacement = {
  /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
  left: {
    transformOrigin: 'right center',
    my: 0,
    mx: 'xxs'
  },
  /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
  right: {
    transformOrigin: 'left center',
    my: 0,
    mx: 'xxs'
  },
  /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
  top: {
    transformOrigin: 'center bottom',
    my: 'xxs',
    mx: 0
  },
  /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
  bottom: {
    transformOrigin: 'center top',
    my: 'xxs',
    mx: 0
  }
};
var arrowBaseStyle = {
  position: 'absolute',
  fontSize: '0.25em',
  color: 'gray',
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: 0,
    height: 0,
    borderStyle: 'solid'
  }
};
var TooltipContent = function TooltipContent(props) {
  var theme = useSafeThemeUI(props);
  var variant = props.variant,
    placement = props.placement,
    border = props.border,
    elevation = props.elevation,
    Component = props.Component,
    ComponentTransitionProps = props.ComponentTransitionProps,
    TransitionProps = props.TransitionProps,
    title = props.title,
    arrow = props.arrow,
    ignoreNonTouchEvents = props.ignoreNonTouchEvents,
    setArrowRef = props.setArrowRef,
    rest = _objectWithoutProperties(props, _excluded);
  var baseTooltipPaneStyle = useMemo(function () {
    return _objectSpread2(_objectSpread2(_objectSpread2({}, ignoreNonTouchEvents.current ? {
      px: 'md',
      py: 'sm',
      fontSize: 'sm'
    } : {}), arrow ? {
      position: 'relative',
      margin: '0'
    } : {}), tooltipPlacement[placement.split('-')[0]]);
  }, [arrow, ignoreNonTouchEvents, placement]);
  return /*#__PURE__*/React.createElement(Component, _extends({
    timeout: get(theme, 'transitions.duration.shortest', 150)
  }, ComponentTransitionProps, TransitionProps), /*#__PURE__*/React.createElement(PanePrivate, _extends({
    variant: variant,
    __themeKey: "tooltips",
    styledBorder: border,
    elevation: elevation,
    __css: baseTooltipPaneStyle
  }, omitSpace(rest)), title, arrow ? /*#__PURE__*/React.createElement(BoxPrivate, {
    as: "span",
    ref: setArrowRef,
    className: "csg-tui-tooltip-arrow",
    __css: arrowBaseStyle
  }) : null));
};

export default TooltipContent;
export { tooltipPlacement };
//# sourceMappingURL=tooltip-content.esm.js.map
